module.exports = __webpack_public_path__ + "img/wesebi-da-pirobebi.f8bc2e1b.png";